import { cn } from '@/lib/utils'
import { forwardRef, type InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, id, required, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-')

    return (
      <div className="space-y-2">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-[15px] font-medium text-text-primary"
          >
            {label}
            {required && <span className="text-danger ml-0.5">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          required={required}
          aria-required={required || undefined}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${inputId}-error` : undefined}
          className={cn(
            'w-full px-4 py-3 bg-white border border-input-border rounded-xl text-text-primary placeholder:text-text-muted/50 text-[15px]',
            'focus:outline-none focus:ring-2 focus:ring-accent/20 focus:border-accent/40',
            'disabled:opacity-40 disabled:cursor-not-allowed',
            'transition-all duration-200',
            error && 'border-danger/40 focus:ring-danger/20',
            className
          )}
          {...props}
        />
        {error && <p id={`${inputId}-error`} className="text-sm text-danger" role="alert">{error}</p>}
      </div>
    )
  }
)

Input.displayName = 'Input'
